import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { About } from "@/components/About";
import { Solutions } from "@/components/Solutions";
import { Features } from "@/components/Features";
import { Process } from "@/components/Process";
import { Enphase } from "@/components/Enphase";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { FloatingActions } from "@/components/FloatingActions";
import { EditorialMarquee } from "@/components/EditorialMarquee";
import { useReveal } from "@/hooks/useReveal";
import { ReactLenis } from "lenis/react";
import { MotionConfig, useReducedMotion } from "framer-motion";
import 'lenis/dist/lenis.css';

const Home = () => {
  useReveal();
  return (
    <div data-testid="home-page" className="bg-white text-slate-900 overflow-x-hidden">
      <Navbar />
      <main>
        <Hero />
        <About />
        <Solutions />
        <Features />
        <Process />
        <Enphase />
        <EditorialMarquee />
        <Contact />
      </main>
      <Footer />
      <FloatingActions />
    </div>
  );
};

function App() {
  const reduced = useReducedMotion();
  const content = <BrowserRouter><Routes><Route path="/" element={<Home />} /></Routes></BrowserRouter>;
  return (
    <MotionConfig reducedMotion="user">
      <div className="App">
        {reduced ? content : <ReactLenis root options={{ autoRaf: true, duration: 1.15, smoothWheel: true }}>{content}</ReactLenis>}
      </div>
    </MotionConfig>
  );
}

export default App;
